import type { SceneLayerValues } from '@jsi/scene-data';

/** Browser-only media capture stays outside the persisted contract. */
export const materializeSceneImages = async (layers: SceneLayerValues): Promise<SceneLayerValues> => {
    const result = structuredClone(layers);
    const cameras = result['camera-poses'];
    if (!cameras) return result;
    const images = [cameras, ...((cameras.cameraPoses ?? []) as Record<string, unknown>[])];
    for (const image of images) {
        for (const key of ['imageUrl', 'thumbnailUrl', 'cameraOverlayIconUrl']) {
            const url = image[key];
            if (typeof url !== 'string' || !url.startsWith('blob:')) continue;
            const response = await fetch(url);
            const blob = await response.blob();
            if (!response.ok || !blob.type.startsWith('image/') || blob.size > 8000000) {
                throw new Error('Cannot embed the camera image (missing, invalid, or larger than 8 MB).');
            }
            const bytes = new Uint8Array(await blob.arrayBuffer());
            let binary = '';
            for (let i = 0; i < bytes.length; i += 4096) binary += String.fromCharCode(...bytes.subarray(i, i + 4096));
            image[key] = `data:${blob.type};base64,${btoa(binary)}`;
        }
    }
    return result;
};
